module.exports = __webpack_public_path__ + "static/curved.bd391b24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/curved.svg
// module id = 230
// module chunks = 35783957827783 95715928098905 172322841747965